import { useApi } from '../../../services';
import type { OfferItem } from '../models/offer-item.model';
import type { ParcelListFilter } from '../models/parcel-list-filter.model';

export const getDemoOffer = async (year?: number, filter?: ParcelListFilter) => {
  const parcelApiService = useApi().parcel;

  try {
    const demoResponse = await parcelApiService.getDemoParcels(year, filter);
    const demoParcels = demoResponse.data || [];

    demoParcels.forEach((demoParcel) => {
      demoParcel.farmName = 'Minta gazdaság';
    });

    return {
      areaLimit: 81,
      id: 'demo-offer',
      name: 'Minta gazdaság',
      parcels: demoResponse.data || [],
      totalArea: 81,
      demo: true
    } as OfferItem;
  } catch {
    return undefined;
  }
};
